/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Interop {
    export class InteropController {
        static $inject = [
            "meevo.AppSettings",
            "$rootScope",
            "$scope",
            "$sce",
            'meevo.components.logging.LoggingService',
            'meevo.plugins.interop.InteropService',
            "meevo.ContextParams",
            '$timeout',
        ];

        public url: string = null;
        public domain: string = null;
        public id: string;

        private iframeElement?: HTMLIFrameElement;
        private _watcher: any;
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $sce: ng.ISCEService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected interopService: InteropService,
            protected contextParams: Meevo.IContextParams,
            private $timeout: ng.ITimeoutService) {
            let inputRoute: any;

            this.domain = appSettings.MEEVO_MODULES_URL;
            $scope.$on('$destroy', () => {
                if (this.iframeElement) {
                    this.interopService.removeWindow(this.iframeElement.id);
                }
                if (this._watcher) {
                    this._watcher();
                    this._watcher = null;
                }
            });

            if (Model.Guard.isSomething(contextParams.params) && Model.Guard.isSomething(contextParams.params.interopParams)) {
                this.updateTargetRoute(contextParams.params.interopParams.targetRoute);
            } else {
                this.loggingService.error(`No target route was defined for a Meevo interop module.`);
                return;
            }

            this._watcher = $scope.$watch(() => (this.contextParams && this.contextParams.params && this.contextParams.params.interopParams), (interopParams: any) => {
                if (Model.Guard.isSomething(contextParams.params) && interopParams && interopParams.id) {
                    const existing = this.interopService.interopRegisteredWindows.find(w => w.id === interopParams.id);
                    existing && this.interopService.updateInteropRoute(interopParams.id, interopParams.targetRoute);
                }
            });
        }

        updateTargetRoute(newRoute: string) {
            if (Model.Guard.isNothing(this.contextParams.params)) {
                this.contextParams.params = { interopParams: { } };
            }
            if (Model.Guard.isNothing(this.contextParams.params.interopParams)) {
                this.contextParams.params.interopParams = { };
            }
            let inputRoute = newRoute;

            // Append any staged querystring params to the iframe URL.
            // consumeQueryParams reads and clears so params only apply once.
            const qp = this.interopService.consumeQueryParams(inputRoute);
            let qs = '';
            if (qp) {
                const searchParams = new URLSearchParams();
                for (const key in qp) {
                    if (qp.hasOwnProperty(key)) {
                        searchParams.append(key, qp[key]);
                    }
                }
                qs = '?' + searchParams.toString();
            }
            const url = `${this.domain}/${inputRoute}${qs}`;

            this.url = this.$sce.trustAsResourceUrl(url);
            const id = this.contextParams.params.interopParams.id || newRoute;
            this.registerIframe(id);
        }

        registerIframe(id: string) {
            this.id = id;
            this.$timeout(() => {
                this.iframeElement = document.getElementById(this.id.toString()) as HTMLIFrameElement;
                if (this.iframeElement) {
                    this.interopService.registerWindow(id, this.iframeElement.contentWindow);
                }
            }, 1000);
        }

    }

    angular.module('meevo.plugins.interop')
        .controller('meevo.plugins.interop.InteropController', InteropController);
}
